import { ref } from 'vue';

export function useToggleable() {
  const isOpen = ref(false);

  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  function toggle() {
    if (isOpen.value) {
      close();
    } else {
      open();
    }
  }

  return {
    isOpen,
    open,
    close,
    toggle,
  };
}
